import { ensureTab, appendRows, getRows } from '../lib/googleSheets';

const TAB = 'PlayerStats';
const HEADERS = [
  'id', 'gamePk', 'gameDate', 'playerId', 'playerName', 'teamSide', 'teamAbbr',
  'position', 'isPitcher', 'AB', 'R', 'H', 'RBI', 'BB', 'K', 'HR', 'AVG',
  'IP', 'H_allowed', 'R_allowed', 'ER', 'BB_pit', 'K_pit', 'HR_allowed',
  'P', 'S', 'ERA', 'created_at', 'updated_at',
];

const generateId = () => (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).substr(2);

export function extractPlayerStatsFromBoxScore(boxScore, gamePk, gameDate) {
  if (!boxScore?.teams) return [];
  const now = new Date().toISOString();
  const stats = [];

  for (const side of ['away', 'home']) {
    const team = boxScore.teams[side];
    const abbr = team?.team?.abbreviation || side.toUpperCase();
    const players = Object.values(team?.players || {});

    for (const p of players) {
      const b = p.stats?.batting;
      const pit = p.stats?.pitching;
      
      const isPitcher = pit && parseFloat(pit.inningsPitched || 0) > 0;
      const isBatter = b && (b.atBats > 0 || b.hits > 0);
      
      if (!isPitcher && !isBatter) continue;

      stats.push([
        generateId(),
        String(gamePk || ''),
        gameDate || '',
        String(p.person?.id || ''),
        p.person?.fullName || '',
        side,
        abbr,
        p.position?.abbreviation || '',
        isPitcher ? 'true' : 'false',
        String(b?.atBats ?? ''),
        String(b?.runs ?? ''),
        String(b?.hits ?? ''),
        String(b?.rbi ?? ''),
        String(b?.baseOnBalls ?? ''),
        String(b?.strikeOuts ?? ''),
        String(b?.homeRuns ?? ''),
        b?.avg ?? '',
        String(pit?.inningsPitched ?? ''),
        String(pit?.hits ?? ''),
        String(pit?.runs ?? ''),
        String(pit?.earnedRuns ?? ''),
        String(pit?.baseOnBalls ?? ''),
        String(pit?.strikeOuts ?? ''),
        String(pit?.homeRuns ?? ''),
        String(pit?.pitchesThrown ?? ''),
        String(pit?.strikes ?? ''),
        pit?.era ?? '',
        now,
        now,
      ]);
    }
  }
  return stats;
}

export async function savePlayerStats(statsRows, gamePk) {
  if (!statsRows.length) return;
  await ensureTab(TAB, HEADERS);

  // Prevent duplicates by checking if gamePk already exists in Column B
  if (gamePk) {
    const existing = await getRows(`${TAB}!B:B`);
    if (existing.some((row) => row[0] === String(gamePk))) {
      return; 
    }
  }

  await appendRows(`${TAB}!A:AC`, statsRows);
}

export async function getStatsByGame(gamePk) {
  await ensureTab(TAB, HEADERS);
  const rows = await getRows(`${TAB}!A2:AC`);
  return rows
    .filter((r) => r[1] === String(gamePk))
    .map((r) => {
      const obj = {};
      HEADERS.forEach((h, i) => (obj[h] = r[i] ?? ''));
      return obj;
    });
}

export async function getAllPlayerStats() {
  await ensureTab(TAB, HEADERS);
  const rows = await getRows(`${TAB}!A2:AC`);
  return rows.map((r) => {
    const obj = {};
    HEADERS.forEach((h, i) => (obj[h] = r[i] ?? ''));
    return obj;
  });
}